import ConfirmButton from "../../../common/components/ConfirmButton";

const TableCellRestRepayActions = ({ restRepayLoan, item }) => {
  return (
    <div>
      <ConfirmButton
        label="Rest repay loan"
        refreshKey={item.Id}
        action={() => {
          restRepayLoan(item.Id);
        }}
      ></ConfirmButton>
    </div>
  );
};

export default TableCellRestRepayActions;
